@import (reference) '../../../../constants/spacing.module.less';

.customer-tags {
  overflow: hidden;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: @space-16;
  flex: 1;
  padding-left: @space-16;
}
